export default __webpack_public_path__ + "static/media/secona.bc3f9c7f.png";